<template>
  <v-container style="max-width: 100%">
    <div
      class="availableServices"
    >

      <!-- SYNC BUTTONS -->
      <div class="d-flex flex-row flex-wrap">
        <v-spacer />

        <v-btn
          color="ppc_darkgreen darken-1"
          class="white--text my-7 ml-2"
          @click="syncPM"
        >
          Sync with Package Maker
        </v-btn>

        <v-btn
          color="ppc_darkgreen darken-1"
          class="white--text my-7 ml-2"
          @click="syncWebsite"
        >
          Sync with Website
        </v-btn>

        <v-btn
          color="ppc_darkgreen darken-1"
          class="white--text my-7 ml-2"
          @click="$router.push({ name: 'ManageImages'})"
        >
          Images
        </v-btn>
      </div>

      <!-- SERVICE LIST -->
      <ServiceList
        :services="available_services_edit"
        :scopeServices="scopeServices"
        @change-scope="changeScope"
        @edit="openService"
        @delete="prepareDeleteService"
        @add-new-service="addAvailableService"
      />

      <ServiceEditor
        :service="updatedAvailableService"
        :services="available_services_edit"
        :dialogService="dialogService"
        :getImage="getImage"
        :getStartDay="getStartDay"
        :getEndDay="getEndDay"
        :typeSelect="typeSelect"
        :week="week"
        :durationSelect="durationSelect"
        :priceTable="priceTable"
        :unitDurationSelect="unitDurationSelect"
        :priceTypeSelect="priceTypeSelect"
        :priceDescSelect="priceDescSelect"
        :headersPriceTable="headersPriceTable"
        :headersAvailableOptions="headersAvailableOptions"
        :updatedAvailableOptions="updatedAvailableOptions"
        :headersRadioGroups="headersRadioGroups"
        :headersRadioOptions="headersRadioOptions"
        :updatedAvailableRadioGroups="updatedAvailableRadioGroups"
        :requirements="requirements"
        :invoiceModes="invoiceModes"
        :spanishLevelSelect="spanishLevelSelect"
        :descriptions="descriptions"
        :resourcesPresets="resourcesPresets"
        :updatedResourcePreset="updatedResourcePreset"
        :getProjectCategory="getProjectCategory"
        :getProjectName="getProjectName"
        :getTour="getTour"
        :dialogOption="dialogOption"
        :dialogRadioOption="dialogRadioOption"
        :dialogDeleteOption="dialogDeleteOption"
        :dialogDeleteRadioGroup="dialogDeleteRadioGroup"
        :dialogRadioGroup="dialogRadioGroup"
        :editedRadioGroup="editedRadioGroup"
        :editedItemOption="editedItemOption"
        :editedRadioOptionItem="editedRadioOptionItem"
        :formTitleOptions="formTitleOptions"
        :selectImageDialog="selectImageDialog"
        :dialogAddResource="dialogAddResource"
        :dialogResource="dialogResource"
        :resourceTypes="resourceTypes"
        :categoriesProjects="categoriesProjects"
        :filterProjects="filterProjects"
        :tourSelect="tourSelect"
        :hasChanges="hasChanges"
        
        @select-image="selectImage"
        @remove-image="removeImage"
        @change-type-icon="changeTypeIcon"
        @change-start-days="changeStartDays"
        @change-end-days="changeEndDays"

        @save-service="saveService"
        
        @close-service-dialog="closeServiceDialog"
        @save-price-table="savePriceTable"
        @cancel-price-table="cancelPriceTable"
        @open-price-table="openPriceTable"
        @remove-last-week="removeLastWeek"
        @reset-price-table="resetPriceTable"

        @add-option="editItemOption"
        @edit-option="editItemOption"
        @close-delete-option="closeDeleteOption"
        @delete-option-confirm="deleteItemConfirmOption"
        @delete-option="deleteItemOption"
        @save-option="saveOptions"
        @close-option="closeDialogOption"

        @open-radio-group="editAddRadioGroup"
        @update-dialog-radio-group="dialogRadioGroup = $event"
        @close-radio-group="closeRadioGroup"
        @save-radio-group="saveRadioGroup"

        @update-dialog-delete-radio-group="dialogDeleteRadioGroup = $event"
        @close-delete-radio-group="closeDeleteRadioGroup"
        @delete-radio-group-confirm="deleteItemConfirmRadioGroup"
        @open-radio-option="openRadioOption"
        @close-radio-option="closeRadioOption"
        @add-edit-radio-option="addEditRadioOption"
        @update-dialog-radio-option="dialogRadioOption = $event"
        @delete-radio-group="deleteRadioGroup"
        @delete-radio-option="deleteRadioOption"

        @update-dialog-add-resource="dialogAddResource = $event"
        @add-resource="addResource"
        @edit-resource="editResource"
        @delete-resource="deleteResourcePreset"
        @save-resource="saveResource"
        @cancel-resource="cancelResource"

        @change-agency="changeAgency"

        @update-select-image-dialog="selectImageDialog = $event"

      />

      <v-dialog
        v-model="confirmDeleteDialog"
        persistent
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">
            Are you sure you want to delete this service?
          </v-card-title>

          <v-card-actions>
            <v-spacer />

            <v-btn
              color="green darken-1"
              text
              @click="confirmDeleteDialog = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              @click="deleteAvailableService()"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </v-container>
</template>

<script>
import ServiceList from './ServiceList.vue';
import ServiceEditor from './ServiceEditor.vue';
import formattedDate from '@/mixins/formattedDate';
import radioGroups_filtered from '@/mixins/radioGroups_filtered';
import options_filtered from '@/mixins/options_filtered';
import compare from '@/mixins/compare';
import dayjs from 'dayjs';

export default {
  name: 'AvailableServices',

  components: {
    ServiceList,
    ServiceEditor,
  },

  mixins: [
    formattedDate,
    radioGroups_filtered,
    options_filtered,
    compare,
  ],

  data() {
    return {
      availableServicesEditLoaded: [],
      available_services_edit: [],
      tourSelect: [],
      updatedAvailableService: {},
      typeSelect: [],
      week: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
      durationSelect: [
        {text: 'business weeks', value: 'businessWeeks'},
        {text: 'weeks', value: 'weeks'},
        {text: 'flexible period', value: 'flexible'},
        {text: 'business days', value: 'businessDays'},
        {text: 'nights', value: 'nights'},
        {text: 'hours', value: 'hours'},
        {text: 'fixed', value: 'fixed'},
      ],
      unitDurationSelect: [
        {text: 'month(s)', value: 'month(s)'},
        {text: 'week(s)', value: 'week(s)'},
        {text: 'hour(s)', value: 'hour(s)'},
        {text: 'day(s)', value: 'day(s)'},
        {text: 'nights', value: 'nights'},
        {text: 'afternoon', value: 'afternoon'},
        {text: 'morning', value: 'morning'},
      ],
      priceDescSelect: [
        {text: 'one time donation', value: 'one time donation'},
        {text: 'one time payment', value: 'one time payment'},
        {text: 'donation per week', value: 'donation per week'},
        {text: 'per week', value: 'per week'},
        {text: 'per night', value: 'per night'},
        {text: 'per hour', value: 'per hour'},
      ],
      priceTable: [],
      headersPriceTable: [
        {
          text: 'Weeks',
          align: 'start',
          sortable: false,
          value: 'weeks',
        },
        { 
          text: 'Price $', 
          value: 'price', 
          sortable: false
        },
      ],
      headersAvailableOptions: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'option_name',
        },
        { text: 'Question', value: 'option_question' },
        { text: 'Fixed price $', value: 'price' },
        { text: 'Variable price $', value: 'varPrice' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headersRadioOptions: [
        {
          text: 'Label',
          align: 'start',
          sortable: false,
          value: 'label',
        },
        { text: 'radioOption_id', value: 'radioOption_id' },
        { text: 'Fixed price', value: 'price' },
        { text: 'Variable price', value: 'varPrice' },
        { text: 'Duration', value: 'duration' },
        { text: 'Minimal Duration', value: 'min_duration' },
        { text: 'Discount after', value: 'discount_after' },
        { text: 'Discount %', value: 'discount_percentage' },
        { text: 'Website', value: 'websiteText' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      updatedAvailableOptions: [],
      dialogOption: false,
      dialogDeleteOption: false,
      dialogRadioGroup: false,
      dialogDeleteRadioGroup: false,
      dialogRadioOption: false,
      dialogAddResource: false,
      editedItemOption: {
        option_name: '',
        option_question: '',
        price: 0,
        varPrice: 0,
        priceFrom: 0,
      },
      editedRadioGroup: {},
      defaultRadioGroup: {
        radio_group_id: null,
        radio_group_name: '',
        radio_group_question: '',
        info_link: '',
        radio_group_value: '',
        options: []
      },
      editedRadioOptionItem: {},
      defaultRadioOption: {
        label: '',
        price: 0,
        varPrice: 0,
        duration: null,
        min_duration: null,
        discount_after: null,
        discount_percentage: null,
        websiteText: '',
        radioOption_id: null,
        radio_group_id: null,
      },
      updatedAvailableRadioGroups: [],
      headersRadioGroups: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'radio_group_name',
        },
        { text: 'Id', value: 'radio_group_id' },
        { text: 'Question', value: 'radio_group_question' },
        { text: 'Options (* = default)', value: 'optionsTxt' },
        { text: 'Info link', value: 'info_link' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      requirements: [
        { Requirement: 'Food preference', Value: 'foodPreference', selected: false },
        { Requirement: 'Pets preference', Value: 'petsPreference', selected: false },
        { Requirement: 'Curriculum Vitae', Value: 'cv', selected: false },
        { Requirement: 'Passport', Value: 'passport', selected: false },
        { Requirement: 'Spanish test', Value: 'spanishTest', selected: false },
      ],
      invoiceModes: [
        {text: 'After apply', value: 'after_apply'},
        {text: 'After availability', value: 'after_availability'},
        {text: 'After review', value: 'after_review'},
      ],
      spanishLevelSelect: [
        {text: 'any level', value: 'beginner, intermediate or advanced'},
        {text: 'beginner', value: 'beginner'},
        {text: 'intermediate', value: 'intermediate'},
        {text: 'advanced', value: 'advanced'},
      ],
      descriptions:[
        {Title: 'General', Value: 'desc_short', data_length: 100},
        {Title: 'Accommodation', Value: 'desc_acc', data_length: 255},
        {Title: 'Study', Value: 'desc_study', data_length: 255},
        {Title: 'Project', Value: 'desc_project', data_length: 255},
        {Title: 'Start', Value: 'desc_start', data_length: 255},
        {Title: 'Includes (appears in invoice)', Value:'desc_incl', data_length: 255},
      ],
      resourcesPresets: [],
      updatedResourcePreset: {},
      priceTypeSelect: [
        {text: 'per business weeks', value: 'per_businessWeek'},
        {text: 'per hour', value: 'per_hour'},
        {text: 'per business day', value: 'per_businessDay'},
        {text: 'per night', value: 'per_night'},
        {text: 'fixed', value: 'fixed'},
        {text: 'per week', value: 'per week'},
      ],
      selectImageDialog: false,
      dialog_add_resource: false,
      resourceTypes: [
        {icon: "$vuetify.icons.icon_volunteer", text:"Volunteer Placement", type_id: 1},
        {icon: "$vuetify.icons.icon_internship", text:"Internship Placement", type_id: 2},
        {icon: "$vuetify.icons.icon_languages", text:"Spanish Course", type_id: 3},
        {icon: "$vuetify.icons.icon_accommodation", text:"Accommodation", type_id: 4},
        {icon: "$vuetify.icons.icon_tours", text:"Tour Agency", type_id: 5},
        {icon: "$vuetify.icons.icon_languages", text:"English Course", type_id: 8},
      ],
      dialogService: false,

      // things removed from the draft
      deletedOptionIds: [],
      deletedRadioGroupIds: [],
      deletedRadioOptionIds: [],
      deletedResourceIds: [],

      confirmDeleteDialog: false,

      originalServiceData: null,

      dialogResource: false,

    }
  },

  computed: {
    formTitleOptions () {
        return this.editedIndexOptions === -1 ? 'New Option' : 'Edit Option'
    },

    formTitleGroups () {
        return this.editedRadioIndex === -1 ? 'New Radiogroup' : 'Edit Radiogroup'
    },

    formTitleRadioOptions () {
        return this.editedRadioOptionIndex === -1 ? 'New Option' : 'Edit Option'
    },

    scopeServices: {
        get() {
            return this.$store.getters.scopeServices
        },
        set(val) {
            this.$store.commit('changeScopeServices', val);
            this.createTable();
        }
    },

    hasChanges() {
      if (!this.originalServiceData) {
        return false
      }

      const currentService = JSON.parse(
        JSON.stringify(this.updatedAvailableService)
      )
      const originalService = JSON.parse(
        JSON.stringify(this.originalServiceData.service)
      )

      // Requirements are compared separately
      delete currentService.requirements
      delete originalService.requirements

      const currentRequirements = this.requirements
        .filter(requirement => requirement.selected)
        .map(requirement => requirement.Value)
        .sort()

      const originalRequirements = this.originalServiceData.service.requirements
        .slice()
        .sort()

      return (
        JSON.stringify(currentRequirements) !== JSON.stringify(originalRequirements) ||
        JSON.stringify(currentService) !== JSON.stringify(originalService) ||
        JSON.stringify(this.updatedAvailableOptions) !== JSON.stringify(this.originalServiceData.options) ||
        JSON.stringify(this.updatedAvailableRadioGroups) !== JSON.stringify(this.originalServiceData.radioGroups) ||
        JSON.stringify(this.resourcesPresets) !== JSON.stringify(this.originalServiceData.resources) ||
        JSON.stringify(this.priceTable) !== JSON.stringify(this.originalServiceData.priceTable)
      )
    },

  },

  beforeCreate () {
    this.$store.dispatch('setLoadingApp', 1)
  },

  created () {
    dayjs.locale("en");
    this.initialize();
  },

  methods: {

    async initialize() {
      this.$store.dispatch('breadcrumbs', ['AvailableServices'])

      const [services, tours] = await Promise.all([
        this.$store.dispatch('getAvailableServicesEdit'),
        this.$store.dispatch('getTours'),
      ])

      this.availableServicesEditLoaded = services
      this.tourSelect = tours

      this.tourSelect.sort(this.dynamicSort('name'))

      this.createTable()

      this.$store.dispatch('setLoadingApp', 0)
    },

    createTable() {

      if (this.scopeServices === 'packagemaker') {
        this.available_services_edit = this.availableServicesEditLoaded.filter(function(select_item) {
          return select_item.packageMaker === 1;
        })
      }
      if (this.scopeServices === 'website') {
        this.available_services_edit = this.availableServicesEditLoaded.filter(function(select_item) {
          return select_item.website === 1;
        })
      }
      if (this.scopeServices === 'active') {
        this.available_services_edit = this.availableServicesEditLoaded.filter(function(select_item) {
          return select_item.active === 1;
        })
      }
      if (this.scopeServices === 'inactive') {
        this.available_services_edit = this.availableServicesEditLoaded.filter(function(select_item) {
          return select_item.active !== 1;
        })
      }
      if (this.scopeServices === 'all') {
        this.available_services_edit = this.availableServicesEditLoaded;
      }
      
    },

    async openService(service_number) {

      this.deletedOptionIds = []
      this.deletedRadioGroupIds = []
      this.deletedRadioOptionIds = []
      this.deletedResourceIds = []

      this.serviceNr = service_number;

      this.$store.dispatch('setLoadingApp', 1)

      await this.getResourcesPresets();
      
      if (service_number !== null) {
        let serviceNr = service_number;
        let tmpService = this.available_services_edit.filter(function(select_item) {
          return select_item.service_number === serviceNr;
        })
        this.updatedAvailableOptions = this.$store.state.availableOptions.filter(function(select_item) {
          return select_item.available_service_number === serviceNr;
        })
        await this.loadRadioGroups();
        this.updatedAvailableService = JSON.parse(JSON.stringify(tmpService[0]));
        if (this.updatedAvailableService.max_duration === undefined) {
          this.updatedAvailableService.max_duration = 0
        }
        this.updatedAvailableServiceIndex = this.available_services_edit.map(function(e) { return e.service_number; }).indexOf(this.updatedAvailableService.service_number)
      }

      for (let i = 0; i < this.requirements.length; i++) {
        this.requirements[i].selected =
          this.updatedAvailableService.requirements.includes(
            this.requirements[i].Value
          )
      }

      this.typeSelect = []

      for (let i = 0; i < this.$store.state.types.length; i++) {
        if (this.$store.state.types[i].text !== 'Promotions') {
          this.typeSelect.push({text: this.$store.state.types[i].text, value: this.$store.state.types[i].id, icon: this.$store.state.types[i].icon})
        }
      }

      let serviceNumber = this.updatedAvailableService.service_number;
      let result = await this.$store.dispatch('getAvailablePriceTable', serviceNumber);
      this.priceTable = [];
      
      if (result.length > 0) {
        this.priceTable = JSON.parse(JSON.stringify(result));
      } 

      this.priceTable.push({weeks: result.length + 1, price: "+"});

      const originalService = JSON.parse(
        JSON.stringify(this.updatedAvailableService)
      )

      originalService.requirements = this.requirements
        .filter(requirement => requirement.selected)
        .map(requirement => requirement.Value)
        .sort()

      this.originalServiceData = {
        service: originalService,
        options: JSON.parse(JSON.stringify(this.updatedAvailableOptions)),
        radioGroups: JSON.parse(JSON.stringify(this.updatedAvailableRadioGroups)),
        resources: JSON.parse(JSON.stringify(this.resourcesPresets)),
        priceTable: JSON.parse(JSON.stringify(this.priceTable)),
      }

      this.$store.dispatch('setLoadingApp', 0)

      this.dialogService = true;
    },

    closeServiceDialog() {

      this.priceTable = []
      this.serviceNr = null
      this.dialogService = false

    },

    async initAllData() {
      this.availableServicesEditLoaded = await this.$store.dispatch('getAvailableServicesEdit')

      this.createTable()

      await Promise.all([
        this.$store.dispatch('getAvailableRadioGroups'),
        this.$store.dispatch('getAvailableOptions'),
        this.$store.dispatch('getAvailableRadioGroupOptions'),
      ])
    },

    async saveService() {
      this.$store.dispatch('setLoadingApp', 1)

      if (this.updatedAvailableService.fixed_deposit === '') {
        this.updatedAvailableService.fixed_deposit = 0
      }

      if (this.updatedAvailableService.variable_deposit === '') {
        this.updatedAvailableService.variable_deposit = 0
      }

      // Save selected requirements
      this.updatedAvailableService.requirements = this.requirements
        .filter(requirement => requirement.selected)
        .map(requirement => requirement.Value)
        .join('')

      // Continue with your existing save logic...

      for (let i = 0; i < this.requirements.length; i++) {
        if (this.requirements[i].selected === this.requirements[i].Value) {
          this.updatedAvailableService.requirements = this.updatedAvailableService.requirements.concat(this.requirements[i].Value);
        }
      }

      if (this.updatedAvailableService.duration_type === 'businessWeeks' || this.updatedAvailableService.duration_type === 'weeks') {
        this.updatedAvailableService.week_slider = 24
      } else if (this.updatedAvailableService.duration_type === 'hours') {
        this.updatedAvailableService.week_slider = 150
      } else {
        this.updatedAvailableService.week_slider = null
      }
      if (this.updatedAvailableService.fixed_deposit === null && this.updatedAvailableService.variable_deposit > 0) {
        this.updatedAvailableService.fixed_deposit = 0;
      }
      if (this.updatedAvailableService.price_type === null || !this.updatedAvailableService.price_type) {
        this.updatedAvailableService.price_type = 'fixed';
      }
      if (!this.updatedAvailableService.price > 0) {
        this.updatedAvailableService.price = 0;
      }
      if (!this.updatedAvailableService.varPrice > 0) {
        this.updatedAvailableService.varPrice = 0;
      }
      if (!this.updatedAvailableService.priceFrom > 0) {
        this.updatedAvailableService.priceFrom = 0;
      }
      if (this.updatedAvailableService.agency > 0) {
        this.updatedAvailableService.fixed_deposit = 0;
        this.updatedAvailableService.variable_deposit = 0;
      }

      let serviceNr = await this.$store.dispatch('insertAvailableService', this.updatedAvailableService)
      if (!this.updatedAvailableService.service_number) {
        this.updatedAvailableService.service_number = serviceNr;
        this.serviceNr = serviceNr;
      }

      // options

      for (const optionId of this.deletedOptionIds) {
        await this.$store.dispatch('deleteAvailableOption', optionId)
      }

      for (const option of this.updatedAvailableOptions) {
        option.available_service_number =
          this.updatedAvailableService.service_number

        await this.$store.dispatch('insertAvailableOption', option)
      }
      
      // radio options

      for (const radioOptionId of this.deletedRadioOptionIds) {
        await this.$store.dispatch(
          'deleteAvailableRadioOption',
          radioOptionId
        )
      }

      // radio groups

      for (const radioGroupId of this.deletedRadioGroupIds) {
        await this.$store.dispatch(
          'deleteAvailableRadioGroup',
          radioGroupId
        )
      }

      for (const radioGroup of this.updatedAvailableRadioGroups) {
        radioGroup.available_service_number =
          this.updatedAvailableService.service_number

        const radioGroupId = await this.$store.dispatch(
          'insertAvailableRadioGroup',
          radioGroup
        )

        if (!radioGroup.radio_group_id) {
          radioGroup.radio_group_id = radioGroupId
        }

        for (const option of radioGroup.options) {
          option.radio_group_id = radioGroup.radio_group_id

          await this.$store.dispatch(
            'insertAvailableRadioOption',
            option
          )
        }
      }

      // resources

      for (const resourceId of this.deletedResourceIds) {
        await this.$store.dispatch(
          'deleteResourcePreset',
          resourceId
        )
      }

      for (const resource of this.resourcesPresets) {
        resource.service_number =
          this.updatedAvailableService.service_number

        await this.$store.dispatch(
          'insertResourcePreset',
          resource
        )
      }

      // price table
      await this.$store.dispatch('deleteAvailablePriceTable', this.updatedAvailableService.service_number)
      if (this.priceTable.length > 1) {
        for (let i = 0; i < this.priceTable.length-1; i++) {
          this.priceTable[i].service_number = this.updatedAvailableService.service_number;
          await this.$store.dispatch('insertAvailablePriceTable', this.priceTable[i]);
        }
      }

      await this.initAllData()

      this.dialogService = false

      this.$store.dispatch('setLoadingApp', 0)

    },
      
    async loadRadioGroups () {
      console.log('loadRadioGroups', this.$store.state.availableRadioGroups, this.serviceNr);
      let serviceNr = this.serviceNr;
      let availableRadioGroups = this.$store.state.availableRadioGroups.filter(function(item) {
        return item.available_service_number === serviceNr;
      })
      console.log('loadRadioGroups #1', availableRadioGroups);
      this.updatedAvailableRadioGroups = JSON.parse(JSON.stringify(availableRadioGroups));
      console.log('loadRadioGroups #2', this.updatedAvailableRadioGroups);
      let i;
      for (i = 0; i < availableRadioGroups.length; i++) {
        let radioOptions = this.$store.state.availableRadioGroupOptions.filter(function(item) {
          return item.radio_group_id === availableRadioGroups[i].radio_group_id;
        })

        this.updatedAvailableRadioGroups[i].options = radioOptions

        this.updatedAvailableRadioGroups[i].optionsTxt =
          this.buildRadioOptionsTxt(this.updatedAvailableRadioGroups[i])
      }
    },

    buildRadioOptionsTxt(radioGroup) {
      let optionsTxt = ''

      for (let j = 0; j < radioGroup.options.length; j++) {
        if (radioGroup.radio_group_value === radioGroup.options[j].label) {
          optionsTxt += '* ' + radioGroup.options[j].label + ' '
        } else {
          optionsTxt += String.fromCharCode(9900) + ' ' + radioGroup.options[j].label + ' '
        }
      }

      return optionsTxt
    },

    async deleteAvailableService() {
      this.confirmDeleteDialog = false

      try {
        await this.$store.dispatch(
          'deleteAvaliableService',
          this.updatedAvailableService.service_number
        )

        this.$store.dispatch(
          'successMessage',
          'Service successfully removed!'
        )

        await this.initAllData()

      } catch (error) {
        this.$store.dispatch(
          'errorMessage',
          'Failed to remove Service'
        )

        console.error('deleteAvailableService:', error)
      }
    },

    getImage(id) {
      if (!this.$store.state.available_images || id == null) {
        return null;
      }

      const image = this.$store.state.available_images.find(
        item => item.id === id
      );

      if (!image || !image.image) {
        return null;
      }

      let bytes;

      if (image.image.type === 'Buffer' && Array.isArray(image.image.data)) {
        bytes = new Uint8Array(image.image.data);
      } else if (typeof image.image === 'string') {
        // Handle Base64 data if the API returns it as a string.
        const binary = atob(image.image);
        bytes = new Uint8Array(binary.length);

        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i);
        }
      } else {
        console.error('Unsupported image format:', image.id);
        return null;
      }

      let binaryString = '';
      const chunkSize = 8192;

      for (let i = 0; i < bytes.length; i += chunkSize) {
        binaryString += String.fromCharCode(
          ...bytes.subarray(i, i + chunkSize)
        );
      }

      return `data:image/jpeg;base64,${btoa(binaryString)}`;
    },

    async addAvailableService () {
      console.log('add Available Service')

      this.updatedAvailableRadioGroups = []
      this.updatedAvailableOptions = []

      this.updatedAvailableService = Object.assign({},
        this.default_available_service
      )

      this.updatedAvailableServiceIndex = -1

      this.updatedAvailableService.service_number = null
      this.updatedAvailableService.allowedStartDays =
        'fridaythursdaywednesdaytuesdaymonday'
      this.updatedAvailableService.allowedEndDays =
        'fridaythursdaywednesdaytuesdaymonday'
      this.updatedAvailableService.requirements = " "
      this.updatedAvailableService.active = 0
      this.updatedAvailableService.currency = '$'
      this.updatedAvailableService.fixed_deposit = 0
      this.updatedAvailableService.variable_deposit = 100
      this.updatedAvailableService.handbookIncluded = 0
      this.updatedAvailableService.website = 0
      this.updatedAvailableService.name = ''
      this.updatedAvailableService.invoice_mode = 'after_review'
      this.updatedAvailableService.planning_days = 0

      await this.openService(null)
      // await this.saveService()
    },

    changeAgency (event) {
      if (event) {
        this.updatedAvailableService.packageMaker = false;
      }
    },

    changeSort (event) {
      this.sortServices = event;
    },

    changeSortDirection (event) {
      this.sortDirection = event;
    },

    changeTypeIcon(event) {

      let type = this.typeSelect.filter(function(select_item) {
        return select_item.value === event
      })

      this.updatedAvailableService.icon = type[0].icon
    },

    removeImage() {
      console.log('removeImage');
      this.updatedAvailableService.image = null
    },

    changeStartDays(event, day) {
      if (
        !event &&
        this.updatedAvailableService.allowedStartDays.includes(day)
      ) {
        this.updatedAvailableService.allowedStartDays =
          this.updatedAvailableService.allowedStartDays.replace(day, '')
      } else if (
        event &&
        !this.updatedAvailableService.allowedStartDays.includes(day)
      ) {
        this.updatedAvailableService.allowedStartDays =
          this.updatedAvailableService.allowedStartDays.concat(day)
      }
    },

    changeEndDays(event, day) {
      if (
        !event &&
        this.updatedAvailableService.allowedEndDays.includes(day)
      ) {
        this.updatedAvailableService.allowedEndDays =
          this.updatedAvailableService.allowedEndDays.replace(day, '')
      } else if (
        event &&
        !this.updatedAvailableService.allowedEndDays.includes(day)
      ) {
        this.updatedAvailableService.allowedEndDays =
          this.updatedAvailableService.allowedEndDays.concat(day)
      }
    },

    getStartDay (day) {
      if (this.updatedAvailableService.allowedStartDays) {
        return this.updatedAvailableService.allowedStartDays.includes(day)
      }
    },

    getEndDay (day) {
      if (this.updatedAvailableService.allowedEndDays) {
        return this.updatedAvailableService.allowedEndDays.includes(day)
      }
    },

    savePriceTable(row) {
      let price = Number(row.price)
      console.log(price, typeof(price))

      let pos = this.priceTable
        .map(function(e) { return e.weeks })
        .indexOf(row.weeks)

      if (price === null || price === '' || isNaN(price)) {
        this.priceTable[pos].price = 0
      } else {
        this.priceTable[pos].price = price
      }

      if (pos + 1 === this.priceTable.length) {
        this.priceTable.push({
          weeks: pos + 2,
          price: "+"
        })
      }

      if (this.priceTable.length > 1) {
        this.updatedAvailableService.duration_type = 'weeks'
        this.updatedAvailableService.duration_text = 'week(s)'
        this.updatedAvailableService.price_type = 'per week'
        this.updatedAvailableService.price_desc = 'per week'
        this.updatedAvailableService.packageMaker = false
      }
    },

    cancelPriceTable(row) {
      this.$refs.editDialogPriceTable.isActive = false

      let pos = this.priceTable
        .map(function(e) { return e.weeks })
        .indexOf(row.weeks)

      if (pos + 1 === this.priceTable.length) {
        this.priceTable[pos].price = "+"
      } else {
        this.priceTable[pos].price = this.priceTable[pos].priceOld
      }
    },

    openPriceTable(row) {
      let pos = this.priceTable
        .map(function(e) { return e.weeks })
        .indexOf(row.weeks)

      if (row.price === '+') {
        this.priceTable[pos].price = null
      }

      this.priceTable[pos].priceOld = row.price
    },

    resetPriceTable() {
      this.priceTable = [
        { weeks: 1, price: "+" }
      ]
    },

    removeLastWeek() {
      this.priceTable.pop()

      let pos = this.priceTable.length - 1
      this.priceTable[pos].price = '+'
    },

    closeDialogOption () {
      this.dialogOption = false;
      this.editedItemOption = Object.assign({}, this.defaultItemOption);
      this.editedIndexOptions = -1
    },

    saveOptions() {
      const tmp = this.editedItemOption.option_name

      const doubleName = this.updatedAvailableOptions.filter(item => {
        return item.option_name === tmp
      })

      if (
        doubleName.length > 0 &&
        this.editedIndexOptions !== this.updatedAvailableOptions.indexOf(doubleName[0])
      ) {
        this.$store.dispatch(
          'errorMessage',
          'The name "' + this.editedItemOption.option_name + '" is already in use!'
        )

        return
      }

      this.editedItemOption.available_service_number = this.serviceNr

      const option = Object.assign({}, this.editedItemOption)

      if (this.editedIndexOptions === -1) {
        this.updatedAvailableOptions.push(option)
      } else {
        this.updatedAvailableOptions.splice(
          this.editedIndexOptions,
          1,
          option
        )
      }

      this.closeDialogOption()
    },

    deleteItemOption (item) {
      this.editedIndexOptions = this.updatedAvailableOptions.indexOf(item);
      this.editedItemOption = Object.assign({}, item);
      this.dialogDeleteOption = true;
    },

    closeDeleteOption () {
      this.dialogDeleteOption = false;
      this.editedItemOption = Object.assign({}, this.defaultItemOption);
      this.editedIndexOptions = -1;
    },

    deleteItemConfirmOption() {
      const optionId = this.editedItemOption.option_id

      // Existing option: remember it for deletion when Save is pressed
      if (optionId) {
        this.deletedOptionIds.push(optionId)
      }

      // Remove it from the current draft
      this.updatedAvailableOptions.splice(
        this.editedIndexOptions,
        1
      )

      this.$store.dispatch(
        'successMessage',
        'Option deleted'
      )

      this.closeDeleteOption()
    },

    editItemOption (item) {
      this.editedIndexOptions = this.updatedAvailableOptions.indexOf(item);
      this.editedItemOption = Object.assign({}, item);
      this.dialogOption = true;
    },

    closeRadioGroup () {
      this.dialogRadioGroup = false;
      this.editedRadioGroup = JSON.parse(JSON.stringify(Object.assign({}, this.defaultRadioGroup)));
      this.editedRadioIndex = -1;
      this.selectedDefaultOption = [];
    },

    saveRadioGroup() {

      console.log("saveRadioGroup", this.editedRadioIndex, this.editedRadioGroup)

      if (this.editedRadioGroup.options.length < 2) {
        this.$store.dispatch(
          'errorMessage',
          'add more options, minimal 2'
        )
        return
      }

      if (this.editedRadioGroup.radio_group_value === '') {
        this.$store.dispatch(
          'errorMessage',
          'select the default option'
        )
        return
      }

      // Check whether the group name is unique
      const groupName = this.editedRadioGroup.radio_group_name.trim()

      const duplicateName = this.updatedAvailableRadioGroups.some(
        (group, index) =>
          group.radio_group_name.trim().toLowerCase() ===
            groupName.toLowerCase() &&
          index !== this.editedRadioIndex
      )

      if (duplicateName) {
        this.$store.dispatch(
          'errorMessage',
          'The radio group name "' + groupName + '" already exists!'
        )
        return
      }

      this.editedRadioGroup.optionsTxt = this.buildRadioOptionsTxt(this.editedRadioGroup)

      this.editedRadioGroup.available_service_number = this.serviceNr;

      const radioGroup = JSON.parse(
        JSON.stringify(this.editedRadioGroup)
      )

      if (this.editedRadioIndex === -1) {
        this.updatedAvailableRadioGroups.push(radioGroup)
      } else {
        this.updatedAvailableRadioGroups.splice(
          this.editedRadioIndex,
          1,
          radioGroup
        )
      }
      this.closeRadioGroup()

    },

    closeDeleteRadioGroup () {
      this.dialogDeleteRadioGroup = false;
      this.editedRadioGroup = JSON.parse(JSON.stringify(Object.assign({}, this.defaultRadioGroup)));
      this.editedRadioIndex = -1;
    },

    deleteItemConfirmRadioGroup() {
      const radioGroupId = this.editedRadioGroup.radio_group_id

      // Existing radio group: remember it for deletion when Save is pressed
      if (radioGroupId) {
        this.deletedRadioGroupIds.push(radioGroupId)
      }

      // Remove it from the current draft
      this.updatedAvailableRadioGroups.splice(
        this.editedRadioIndex,
        1
      )

      this.$store.dispatch(
        'successMessage',
        'Radiogroup deleted'
      )

      this.closeDeleteRadioGroup()
    },

    deleteRadioGroup (item) {
      this.editedRadioIndex = this.updatedAvailableRadioGroups.indexOf(item)
      this.editedRadioGroup = Object.assign({}, item);
      this.dialogDeleteRadioGroup = true;
    },

    editAddRadioGroup(item) {
      if (item) {
        this.editedRadioIndex =
          this.updatedAvailableRadioGroups.indexOf(item)

        this.editedRadioGroup = JSON.parse(
          JSON.stringify(Object.assign({}, item))
        )
      } else {
        this.editedRadioGroup = JSON.parse(
          JSON.stringify(Object.assign({}, this.defaultRadioGroup))
        )
      }

      this.dialogRadioGroup = true
    },

    closeRadioOption () {
      this.dialogRadioOption = false;
      this.editedRadioOptionItem = Object.assign({}, this.editedRadioOptionItem);
      this.editedRadioOptionIndex = -1;
    },

    openRadioOption (item) {

      if (item) {
        this.editedRadioOptionIndex =
          this.editedRadioGroup.options.indexOf(item)

        this.editedRadioOptionItem =
          JSON.parse(JSON.stringify(item))
      } else {
        this.editedRadioOptionItem =
          JSON.parse(JSON.stringify(this.defaultRadioOption))

        this.editedRadioOptionIndex = -1
      }

      this.dialogRadioOption = true
    },

    addEditRadioOption () {
      if (this.editedRadioOptionIndex === -1) {
        const itemName = this.editedRadioOptionItem.label

        const doubleName = this.editedRadioGroup.options.filter(function(select_item) {
          return select_item.label === itemName
        })

        if (doubleName.length > 0) {
          this.$store.dispatch(
            'errorMessage',
            'The label "' + this.editedRadioOptionItem.label + '" already exists!'
          )
        } else {
          this.editedRadioOptionItem.radioOption_id = null
          this.editedRadioOptionItem.radio_group_id = null

          this.editedRadioGroup.options.push(this.editedRadioOptionItem)

          this.editedRadioGroup.optionsTxt = this.buildRadioOptionsTxt(this.editedRadioGroup)

          this.dialogRadioOption = false
          this.editedRadioOptionItem = Object.assign({}, this.defaultRadioOption)
        }
      } else {
        this.editedRadioGroup.options.splice(
          this.editedRadioOptionIndex,
          1,
          this.editedRadioOptionItem
        )

        this.editedRadioGroup.optionsTxt = this.buildRadioOptionsTxt(this.editedRadioGroup)

        this.dialogRadioOption = false
        this.editedRadioOptionItem = Object.assign({}, this.defaultRadioOption)
      }
    },

    deleteRadioOption(item) {
      const pos = this.editedRadioGroup.options.indexOf(item)

      if (pos === -1) return

      if (item.radioOption_id) {
        this.deletedRadioOptionIds.push(item.radioOption_id)
      }

      this.editedRadioGroup.options.splice(pos, 1)
    },

    async getResourcesPresets() {
      this.resourcesPresets = await this.$store.dispatch(
        'getResourcesPresetsServiceNr',
        this.serviceNr
      )

      for (let i = 0; i < this.resourcesPresets.length; i++) {
        let type_id = this.resourcesPresets[i].type_id

        this.resourcesPresets[i].typeName =
          this.$store.state.types.filter(function(select_item) {
            return select_item.id === type_id
          })[0].text
      }
    },

    getProjectCategory(categoryId) {
      if (this.$store.state.projectCategories.length > 0) {
        return this.$store.state.projectCategories.filter(function(select_item) {
          return select_item.id === categoryId
        })[0].name
      } else {
        return []
      }
    },

    getProjectName(projectId) {
      if (this.$store.state.projects.length > 0) {
        return this.$store.state.projects.filter(function(select_item) {
          return select_item.id === projectId
        })[0].name
      } else {
        return []
      }
    },

    getTour(tourId) {
      if (this.tourSelect.length > 0) {
        return this.tourSelect.filter(function(select_item) {
          return select_item.id === tourId
        })[0]
      } else {
        return []
      }
    },

    editResource(resource) {
      this.updatedResourcePreset = JSON.parse(JSON.stringify(resource));
      this.dialogResource = true;
    },

    saveResource() {
      const index = this.resourcesPresets.findIndex(resource => {
        if (this.updatedResourcePreset.id !== null) {
          return resource.id === this.updatedResourcePreset.id
        }

        return resource._tempId === this.updatedResourcePreset._tempId
      })

      if (index !== -1) {
        this.resourcesPresets.splice(
          index,
          1,
          JSON.parse(JSON.stringify(this.updatedResourcePreset))
        )
      }

      this.updatedResourcePreset = {}
      this.dialogResource = false
    },

    cancelResource() {
      this.updatedResourcePreset = {}
      this.dialogResource = false
    },

    deleteResourcePreset(resourcePresetId) {
      const index = this.resourcesPresets.findIndex(
        resource => resource.id === resourcePresetId
      )

      if (index === -1) {
        return
      }

      // Existing resource: remember it for deletion when Save is pressed
      if (resourcePresetId) {
        this.deletedResourceIds.push(resourcePresetId)
      }

      // Remove it from the draft
      this.resourcesPresets.splice(index, 1)
    },

    addResource(type_id) {
      this.dialog_add_resource = false

      const resourcesSameType = this.resourcesPresets.filter(
        resource => resource.type_id === type_id
      )

      let number_type = 1

      if (resourcesSameType.length > 0) {
        number_type =
          Math.max(...resourcesSameType.map(resource => resource.number_type)) + 1
      }

      const typeName = this.$store.state.types.find(
        type => type.id === type_id
      ).text

      const resourcePreset = {
        id: null,
        _tempId: crypto.randomUUID(),

        service_number: this.serviceNr,
        type_id: type_id,

        typeName: typeName,
        number_type: number_type,
        placement_id: null,
        course_id: null,
        room_id: null,
        tour_placement_id: null,
        info_to_client: null,
        info_to_provider: null,
        reserved: null,
        start: null,
        end: null,
      }

      this.resourcesPresets.push(resourcePreset)
    },

    categoriesProjects(resourceType) {
      let type

      if (resourceType === 1) {
        type = 'Volunteering'
      } else {
        type = 'Internship'
      }

      let selection = this.$store.state.projects.filter(function(select_item) {
        return select_item.type === type
      })

      return selection.sort(this.dynamicSort('category'))
    },

    filterProjects(resourceType, categoryId, projectId) {
      let type
      let selection

      if (resourceType === 1) {
        type = 'Volunteering'
      } else {
        type = 'Internship'
      }

      if (projectId && !categoryId) {
        console.log(resourceType, categoryId, projectId)

        selection = this.$store.state.projects.filter(function(select_item) {
          return (
            select_item.id === projectId &&
            select_item.type &&
            select_item.obsolete === null
          )
        })
      } else {
        if (categoryId) {
          selection = this.$store.state.projects.filter(function(select_item) {
            return (
              select_item.category_id === categoryId &&
              select_item.type === type &&
              select_item.obsolete === null
            )
          })
        } else {
          selection = this.$store.state.projects.filter(function(select_item) {
            return (
              select_item.type === type &&
              select_item.obsolete === null
            )
          })
        }
      }

      return selection.sort(this.dynamicSort('name'))
    },

    changeScope(val) {
      this.$store.commit('changeScopeServices', val);
      this.createTable();
    },

    prepareDeleteService(serviceNumber) {
      this.updatedAvailableService.service_number = serviceNumber
      this.confirmDeleteDialog = true
    },

    selectImage(imageId) {
      this.updatedAvailableService.image = imageId
      this.selectImageDialog = false
    },

    // =====================================================================================================================


    async syncPM () {
      this.$store.dispatch('progressAdvance', 0)
      this.$store.dispatch('showProgressBar', true)

      try {
        // 1. Load Admin/source data
        const imagesVPS = await this.$store.dispatch(
          'getAvailableImages_vps'
        )

        const availablePriceTables = await this.$store.dispatch(
          'getAvailablePriceTables'
        )

        await this.$store.dispatch('getAvailableImages')

        const availableImages = [
          ...this.$store.state.available_images
        ]

        const availableOptions = [
          ...this.$store.state.availableOptions
        ]

        const availableRadioGroups = [
          ...this.$store.state.availableRadioGroups
        ]

        const availableRadioGroupOptions = [
          ...this.$store.state.availableRadioGroupOptions
        ]

        const availableServices =
          this.available_services_edit.filter(
            item => item.packageMaker === 1 &&
                    item.active === 1 &&
                    item.type_id !== 0
          )

        // 2. Load current VPS records.
        // These actions need to return arrays of records.
        const [
          servicesVPS,
          priceTablesVPS,
          optionsVPS,
          radioGroupsVPS,
          radioOptionsVPS
        ] = await Promise.all([
          this.$store.dispatch('getAvailableServices_vps'),
          this.$store.dispatch('getAvailablePriceTables_vps'),
          this.$store.dispatch('getAvailableOptions_vps'),
          this.$store.dispatch('getAvailableRadioGroups_vps'),
          this.$store.dispatch('getAvailableRadioOptions_vps')
        ])

        // 3. Build the source datasets for each table
          const serviceNumbers = new Set(
            availableServices.map(item => item.service_number)
          )

          // Services using standard pricing should not sync price-table rows
          const servicesWithStandardPricing = new Set(
            availableServices
              .filter(service => service.pricingMethod === 'standard')
              .map(service => service.service_number)
          )

          const priceTablesToSync = availablePriceTables.filter(
            item =>
              serviceNumbers.has(item.service_number) &&
              !servicesWithStandardPricing.has(item.service_number)
          )

          const optionsToSync = availableOptions.filter(
            item => serviceNumbers.has(item.available_service_number)
          )

          const radioGroupsToSync = availableRadioGroups.filter(
            item => serviceNumbers.has(item.available_service_number)
          )

          const radioGroupIds = new Set(
            radioGroupsToSync.map(item => item.radio_group_id)
          )

          const radioOptionsToSync = availableRadioGroupOptions.filter(
            item => radioGroupIds.has(item.radio_group_id)
          )
          
        // 4. Determine which records need to be removed.
        // Children are removed before their parents.

        const serviceIds = new Set(
          availableServices.map(item => item.service_number)
        )

        const priceTableIds = new Set(
          priceTablesToSync.map(item => item.id)
        )

        const optionIds = new Set(
          optionsToSync.map(item => item.option_id)
        )

        const radioGroupSourceIds = new Set(
          radioGroupsToSync.map(item => item.radio_group_id)
        )

        const radioOptionIds = new Set(
          radioOptionsToSync.map(item => item.radioOption_id)
        )

        const radioGroupsToDelete = radioGroupsVPS.filter(
          item => !radioGroupSourceIds.has(item.id)
        )

        const radioOptionsToDelete = radioOptionsVPS.filter(
          item => !radioOptionIds.has(item.id)
        )

        const optionsToDelete = optionsVPS.filter(
          item => !optionIds.has(item.id)
        )

        const priceTablesToDelete = priceTablesVPS.filter(
          item => !priceTableIds.has(item.id)
        )

        const servicesToDelete = servicesVPS.filter(
          item => !serviceIds.has(item.id)
        )

        // 5. Determine image changes
        const vpsImageIds = new Set(
          imagesVPS.map(item => item.id)
        )

        const localImageIds = new Set(
          availableImages.map(item => item.id)
        )

        const imagesToDelete = imagesVPS.filter(
          item => !localImageIds.has(item.id)
        )

        const imagesToUpload = availableImages.filter(
          item => !vpsImageIds.has(item.id)
        )

        // 6. Calculate the work.
        // Upserts are performed for every source record so that
        // changes to existing records are also synchronized.
        const totalSteps =
          imagesToDelete.length +
          imagesToUpload.length +
          radioOptionsToDelete.length +
          radioGroupsToDelete.length +
          optionsToDelete.length +
          priceTablesToDelete.length +
          servicesToDelete.length +
          availableServices.length +
          priceTablesToSync.length +
          optionsToSync.length +
          radioGroupsToSync.length +
          radioOptionsToSync.length

        let completedSteps = 0

        const advance = () => {
          completedSteps++

          const progress = totalSteps > 0
            ? Math.min(
                100,
                Math.round((completedSteps / totalSteps) * 100)
              )
            : 100

          this.$store.dispatch('progressAdvance', progress)
        }

        // 7. Synchronize images
        for (const image of imagesToDelete) {
          await this.$store.dispatch(
            'deleteImage_vps',
            image.id
          )
          advance()
        }

        for (const image of imagesToUpload) {
          await this.$store.dispatch(
            'uploadImage_vps',
            image
          )
          advance()
        }

        // 8. Delete stale child records first
        for (const item of radioOptionsToDelete) {
          await this.$store.dispatch(
            'deleteAvailableRadioOption_vps',
            item.id
          )
          advance()
        }

        for (const item of radioGroupsToDelete) {
          await this.$store.dispatch(
            'deleteAvailableRadioGroup_vps',
            item.id
          )
          advance()
        }

        for (const item of optionsToDelete) {
          await this.$store.dispatch(
            'deleteAvailableOption_vps',
            item.id
          )
          advance()
        }

        for (const item of priceTablesToDelete) {
          await this.$store.dispatch(
            'deleteAvailablePriceTable_vps',
            item.id
          )
          advance()
        }

        // 9. Delete stale services after their children
        for (const item of servicesToDelete) {
          await this.$store.dispatch(
            'deleteAvailableService_vps',
            item.id
          )
          advance()
        }

        // 10. Upsert services before dependent records
        for (const service of availableServices) {
          await this.$store.dispatch(
            'upsertAvailableService_vps',
            service
          )
          advance()
        }

        for (const priceTable of priceTablesToSync) {
          await this.$store.dispatch(
            'upsertAvailablePriceTable_vps',
            priceTable
          )
          advance()
        }

        for (const option of optionsToSync) {
          await this.$store.dispatch(
            'upsertAvailableOption_vps',
            option
          )
          advance()
        }

        for (const radioGroup of radioGroupsToSync) {
          await this.$store.dispatch(
            'upsertAvailableRadioGroup_vps',
            radioGroup
          )
          advance()
        }

        for (const radioOption of radioOptionsToSync) {
          await this.$store.dispatch(
            'upsertAvailableRadioOption_vps',
            radioOption
          )
          advance()
        }

        this.$store.dispatch('progressAdvance', 100)

        this.$store.dispatch(
          'successMessage',
          'Packagemaker successfully synchronised'
        )
      } catch (error) {
        console.error('syncPM failed:', error)

        this.$store.dispatch(
          'errorMessage',
          'Packagemaker synchronisation failed. Please check the console and verify the VPS data.'
        )
      } finally {
        this.$store.dispatch('showProgressBar', false)
        this.$store.dispatch('progressAdvance', 0)
      }
    },

    async syncWebsite () {
      console.log('syncWebsite');

      this.$store.dispatch('progressAdvance', 0);
      this.$store.dispatch('showProgressBar', true);

      try {
          let progress = 1;

          const availableServices = this.available_services_edit.filter(
              select_item => select_item.website === 1 && select_item.active === 1
          );

          let step = (100 - progress) / availableServices.length;

          // IMPORTANT: wait for DELETE to finish successfully
          await this.$store.dispatch('deleteAllAvailableServices_website');

          console.log('DELETE completed successfully');

          for (let i = 0; i < availableServices.length; i++) {

              progress = progress + step;
              this.$store.dispatch('progressAdvance', progress);

              if (
                  availableServices[i].websiteText !== null &&
                  availableServices[i].websiteText !== undefined
              ) {
                  let payload = {
                      service_number_option: availableServices[i].service_number,
                      websiteText: availableServices[i].websiteText,
                      comment: availableServices[i].name,
                  };

                  console.log('Inserting service', payload);

                  await this.$store.dispatch(
                      'insertAvailableService_website',
                      payload
                  );
              }

              let serviceNr = availableServices[i].service_number;

              let availableRadioGroups =
                  this.$store.state.availableRadioGroups.filter(
                      item => item.available_service_number === serviceNr
                  );

              for (let j = 0; j < availableRadioGroups.length; j++) {

                  let radioOptions =
                      this.$store.state.availableRadioGroupOptions.filter(
                          item =>
                              item.radio_group_id ===
                              availableRadioGroups[j].radio_group_id
                      );

                  for (let k = 0; k < radioOptions.length; k++) {

                      if (
                          radioOptions[k].websiteText !== null &&
                          radioOptions[k].websiteText !== undefined
                      ) {
                          let payload = {
                              service_number_option:
                                  availableServices[i].service_number +
                                  '-' +
                                  radioOptions[k].radioOption_id,

                              websiteText: radioOptions[k].websiteText,

                              comment: radioOptions[k].label,
                          };

                          console.log('Inserting radio option', payload);

                          await this.$store.dispatch(
                              'insertAvailableService_website',
                              payload
                          );
                      }
                  }
              }
          }

          this.$store.dispatch('successMessage',
              'Services successfully synchronised with website'
          );

      } catch (err) {
          console.error('syncWebsite failed:', err);

          this.$store.dispatch(
              'errorMessage',
              'There was an error synchronising the services'
          );

      } finally {
          this.$store.dispatch('showProgressBar', false);
          this.$store.dispatch('progressAdvance', 0);
      }
    },

  }

}

</script>